































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import QuicksightDashboard from '@/components/QuicksightDashboard.vue';
import {Application} from '@/types';
import {Action, Getter} from 'vuex-class';
import ApplicationService from '@/services/application.service';
import {Route} from 'vue-router';

@Component({
  components: {QuicksightDashboard},
})
export default class ApplicationContainer extends Vue {

  private get getNRUrl() {
    let url = '';
    if (this.currentApplication!.type === 'nodered') {
      url = this.currentApplication!.reference;
    }
    return url;
  }
  @Getter private hasPermission: any;
  @Getter private applications!: any; // Make sure your store type has { applications: [] }
  @Getter private activeOrganisationId!: any;
  @Getter private login!: any;
  @Getter private activeOrganisation: any;
  @Action private addApplicationsAsync: any;
  private applicationSelected: boolean = false;
  private currentApplication: Application | null = null;
  private selectedAppUrl: string | null = null;
  private loading: boolean = false;
  private key = 0;

  public async resetCurrentApplication() {
    this.$router.push({name: 'consume-home', params: { organisationId: this.activeOrganisationId }});
    this.currentApplication = null;
    this.applicationSelected = false;
  }

  @Watch('activeOrganisationId')
  private onOrgSwitch() {
    this.resetCurrentApplication();
  }

  @Watch('applications', { deep: true })
  private onApplicationsLoaded() {
    if (!this.applicationSelected) {
      this.findAndLoadApplication();
    }
  }

  private async mounted() {
    this.loading = true;
    this.currentApplication = null;
    this.applicationSelected = false;
    if (!this.applications || !this.applications.applications || this.applications.applications.length === 0) {
      await this.addApplicationsAsync();
    }
    this.findAndLoadApplication();
    this.loading = false;
  }

  private findAndLoadApplication() {
    const appStringId = this.$route.params.id;

    if (!appStringId || Number(appStringId) <= 0) { return; }
    const appList = this.applications.applications || [];

    if (appList.length === 0) {
      return;
    }

    const appId = Number(appStringId);
    const foundApp = appList.find((app: any) => app.id === appId);

    if (foundApp) {
      this.currentApplication = foundApp;
      this.applicationSelected = true;
      this.setSelectedAppUrl();
    } else {
      this.$router.push({name: 'consume-home', params: { organisationId: this.activeOrganisationId }});
    }
  }

  private async setSelectedAppUrl() {
    if (this.currentApplication) {
      if (this.currentApplication.type === 'daizy') {
        const { sessionId } = await ApplicationService.getApplicationSessionId(this.currentApplication.id);
        this.selectedAppUrl = this.currentApplication.src + '?token=' + sessionId;
      } else if (this.currentApplication.type === 'external') {
        if (process.env.NODE_ENV === 'production' && this.activeOrganisationId === 15) {
          const deviceLabToken = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjIzOCwidXNlckVtYWlsIjoiYXBpLXVzZXItMTY0NDg2MzkxMzk0NCIsImlhdCI6MTY0NDg2MzkxNH0.UcIZ1LaZUzEOVHExrPLXy1M_tpr2xA40Sgo7yPOUFrE`;
          this.selectedAppUrl = `${this.currentApplication.src}?token=${deviceLabToken}`;
          return;
        }
        this.selectedAppUrl = this.currentApplication.src.includes('?token') ? this.currentApplication.src : `${this.currentApplication.src}?token=${this.login.token}&orgId=${this.activeOrganisationId}&orgSlug=${this.activeOrganisation[0].slug}`;
      } else {
        this.selectedAppUrl = this.currentApplication.src;
      }
    }
  }



}
